import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

const AccessoriesInfoPopup = ({ setEntryPopup, setPrice }) => {
  const closePopup = e => {
    const popup = e.target.closest(`[data-popup-name="accessories-info-popup"]`);
    popup.classList.remove('open');
    setEntryPopup();
    setPrice();
    reactLocalStorage.setObject('entryAccessories', false);
  };
  return (
    <>
      <h2>Przygotowaliśmy dla Ciebie propozycję wyposażenia Twojej szafy</h2>
      <p>
        Możesz je dowolnie zmieniać lub usunąć wszystkie akcesoria przyciskiem w dolnej części
        ekranu i wybrać własne.
      </p>
      <div className="pop-up__buttons">
        <button className="button clean-accessories__button" onClick={closePopup}>
          OK
        </button>
      </div>
    </>
  );
};
export default AccessoriesInfoPopup;
